<template>
  <div class="approval-manage">
    <breadcrumb :breadcrumb="breadcrumb" />

    <div class="approvalBox">
      <el-tabs
        v-model="approvalPageActiveName"
        @tab-click="tabClick"
        type="card"
      >
        <el-tab-pane label="入住申请审批" name="checkInApplicationApproval">
          <form>
            <div class="form-line">
              <div class="textBox" style="margin-right: 20px;">
                <b class="red">*</b>
                <span class="line-text">是否启用：</span>
              </div>
              <el-switch
                v-model="useFlagOnPage"
                active-text="是"
                :disabled="!modifyState"
                inactive-text="否"
              >
              </el-switch>
            </div>
            <div
              class="form-line"
              v-for="(item, index) in flowDetails"
              :key="item.index"
            >
              <div class="textBox" style="margin-right: 20px;">
                <b class="red" v-if="useFlagOnPage">*</b>
                <span class="line-text">{{ item.index }}级审批人：</span>
              </div>
              <el-select
                v-model="item.accountCode"
                filterable
                remote
                reserve-keyword
                placeholder="请输入关键词"
                :loading="accountLoading"
                size="mini"
                style="width: 220px"
                :disabled="!modifyState"
                @change="accountChange(item, index)"
                :remote-method="accountRemoteMethod"
              >
                <el-option
                  v-for="item in accountList"
                  :key="item.code"
                  :label="item._lable"
                  :value="item.code"
                >
                </el-option>
              </el-select>
              <i
                class="el-icon-circle-plus-outline"
                style="line-height: 32px;font-size: 18px;color: #00A0E6;margin: 0 10px 0 10px;cursor: pointer;"
                @click="addFlowDetails()"
                v-if="
                  item.index < 3 &&
                    item.index === flowDetails.length &&
                    modifyState
                "
              ></i>
              <i
                class="el-icon-remove-outline"
                style="line-height: 32px;font-size: 18px;color: #f25721;margin: 0 0 0 10px;cursor: pointer;"
                @click="removeFlowDetails(index)"
                v-if="item.index > 1 && modifyState"
              ></i>
            </div>

            <div
              class="form-btn-box"
              v-if="!modifyState && permissionCodes.indexOf('001013001') !== -1"
              style="display: flex;justify-content: center;"
            >
              <button-confirm @confirm="modify" value="修改" />
            </div>
            <div class="form-btn-box" v-if="modifyState">
              <button-confirm @confirm="confirm" />
              <button-cancel @cancel="cancel" />
            </div>
          </form>
        </el-tab-pane>
        <el-tab-pane label="合同审批" name="contractApproval">
          <div class="approval-config-area">
            <btn-config
              permission-code="001013001"
              :forecast-text="forecastText"
              :is-disabled="isDisabled"
              @modifyConfig="modifyConfig"
              @saveConfig="confirmContract"
              @cancelConfig="cancelConfig"
            ></btn-config>
            <config-content
              ref="configContentRef"
              :flow-node-configs="flowNodeConfigs"
              :modify-state="!isDisabled"
              @newValue="onNodeConfigChange"
              @changeSwitch="changeSwitch"
            ></config-content>
          </div>
        </el-tab-pane>
        <el-tab-pane label="电费充值审批" name="approvalOfPowerChargeRecharge">
          <form>
            <div class="form-line">
              <div class="textBox" style="margin-right: 20px;">
                <b class="red">*</b>
                <span class="line-text">是否启用：</span>
              </div>
              <el-switch
                v-model="useFlagOnPage"
                active-text="是"
                :disabled="!modifyState"
                inactive-text="否"
              >
              </el-switch>
            </div>
            <div
              class="form-line"
              v-for="(item, index) in flowDetails"
              :key="item.index"
            >
              <div class="textBox" style="margin-right: 20px;">
                <b class="red" v-if="useFlagOnPage">*</b>
                <span class="line-text">{{ item.index }}级审批人：</span>
              </div>
              <el-select
                v-model="item.accountCode"
                filterable
                remote
                reserve-keyword
                placeholder="请输入关键词"
                :loading="accountLoading"
                size="mini"
                style="width: 220px"
                :disabled="!modifyState"
                @change="accountChange(item, index)"
                :remote-method="accountRemoteMethod"
              >
                <el-option
                  v-for="item in accountList"
                  :key="item.code"
                  :label="item._lable"
                  :value="item.code"
                >
                </el-option>
              </el-select>
              <i
                class="el-icon-circle-plus-outline"
                style="line-height: 32px;font-size: 18px;color: #00A0E6;margin: 0 10px 0 10px;cursor: pointer;"
                @click="addFlowDetails()"
                v-if="
                  item.index < 3 &&
                    item.index === flowDetails.length &&
                    modifyState
                "
              ></i>
              <i
                class="el-icon-remove-outline"
                style="line-height: 32px;font-size: 18px;color: #f25721;margin: 0 0 0 10px;cursor: pointer;"
                @click="removeFlowDetails(index)"
                v-if="item.index > 1 && modifyState"
              ></i>
            </div>

            <div
              class="form-btn-box"
              v-if="!modifyState && permissionCodes.indexOf('001013001') !== -1"
              style="display: flex;justify-content: center;"
            >
              <button-confirm @confirm="modify" value="修改" />
            </div>
            <div class="form-btn-box" v-if="modifyState">
              <button-confirm @confirm="confirm" />
              <button-cancel @cancel="cancel" />
            </div>
          </form>
        </el-tab-pane>
        <el-tab-pane
          label="水费充值审批"
          name="waterApprovalOfPowerChargeRecharge"
        >
          <form>
            <div class="form-line">
              <div class="textBox" style="margin-right: 20px;">
                <b class="red">*</b>
                <span class="line-text">是否启用：</span>
              </div>
              <el-switch
                v-model="useFlagOnPage"
                active-text="是"
                :disabled="!modifyState"
                inactive-text="否"
              >
              </el-switch>
            </div>
            <div
              class="form-line"
              v-for="(item, index) in flowDetails"
              :key="item.index"
            >
              <div class="textBox" style="margin-right: 20px;">
                <b class="red" v-if="useFlagOnPage">*</b>
                <span class="line-text">{{ item.index }}级审批人：</span>
              </div>
              <el-select
                v-model="item.accountCode"
                filterable
                remote
                reserve-keyword
                placeholder="请输入关键词"
                :loading="accountLoading"
                size="mini"
                style="width: 220px"
                :disabled="!modifyState"
                @change="accountChange(item, index)"
                :remote-method="accountRemoteMethod"
              >
                <el-option
                  v-for="item in accountList"
                  :key="item.code"
                  :label="item._lable"
                  :value="item.code"
                >
                </el-option>
              </el-select>
              <i
                class="el-icon-circle-plus-outline"
                style="line-height: 32px;font-size: 18px;color: #00A0E6;margin: 0 10px 0 10px;cursor: pointer;"
                @click="addFlowDetails()"
                v-if="
                  item.index < 3 &&
                    item.index === flowDetails.length &&
                    modifyState
                "
              ></i>
              <i
                class="el-icon-remove-outline"
                style="line-height: 32px;font-size: 18px;color: #f25721;margin: 0 0 0 10px;cursor: pointer;"
                @click="removeFlowDetails(index)"
                v-if="item.index > 1 && modifyState"
              ></i>
            </div>

            <div
              class="form-btn-box"
              v-if="!modifyState && permissionCodes.indexOf('001013001') !== -1"
              style="display: flex;justify-content: center;"
            >
              <button-confirm @confirm="modify" value="修改" />
            </div>
            <div class="form-btn-box" v-if="modifyState">
              <button-confirm @confirm="confirm" />
              <button-cancel @cancel="cancel" />
            </div>
          </form>
        </el-tab-pane>
        <!--        <el-tab-pane label="蒸汽充值审批" name="steamApprovalOfPowerChargeRecharge">-->
        <!--          <form>-->
        <!--            <div class="form-line">-->
        <!--              <div class="textBox" style="margin-right: 20px;">-->
        <!--                <b class="red">*</b>-->
        <!--                <span class="line-text">是否启用：</span>-->
        <!--              </div>-->
        <!--              <el-switch-->
        <!--                v-model="useFlagOnPage"-->
        <!--                active-text="是"-->
        <!--                :disabled="!modifyState"-->
        <!--                inactive-text="否">-->
        <!--              </el-switch>-->
        <!--            </div>-->
        <!--            <div class="form-line" v-for="(item, index) in flowDetails" :key="item.index">-->
        <!--              <div class="textBox" style="margin-right: 20px;">-->
        <!--                <b class="red" v-if="useFlagOnPage">*</b>-->
        <!--                <span class="line-text">{{item.index}}级审批人：</span>-->
        <!--              </div>-->
        <!--              <el-select-->
        <!--                v-model="item.accountCode"-->
        <!--                filterable-->
        <!--                remote-->
        <!--                reserve-keyword-->
        <!--                placeholder="请输入关键词"-->
        <!--                :loading="accountLoading"-->
        <!--                size="mini" style="width: 220px"-->
        <!--                :disabled="!modifyState"-->
        <!--                @change="accountChange(item, index)"-->
        <!--                :remote-method="accountRemoteMethod">-->
        <!--                <el-option-->
        <!--                  v-for="item in accountList"-->
        <!--                  :key="item.code"-->
        <!--                  :label="item._lable"-->
        <!--                  :value="item.code">-->
        <!--                </el-option>-->
        <!--              </el-select>-->
        <!--              <i class="el-icon-circle-plus-outline" style="line-height: 32px;font-size: 18px;color: #00A0E6;margin: 0 10px 0 10px;cursor: pointer;" @click="addFlowDetails()" v-if="item.index < 3 && item.index === flowDetails.length && modifyState"></i>-->
        <!--              <i class="el-icon-remove-outline" style="line-height: 32px;font-size: 18px;color: #f25721;margin: 0 0 0 10px;cursor: pointer;" @click="removeFlowDetails(index)" v-if="item.index > 1 && modifyState"></i>-->
        <!--            </div>-->

        <!--            <div class="form-btn-box" v-if="!modifyState && permissionCodes.indexOf('001013001') !== -1" style="display: flex;justify-content: center;">-->
        <!--              <button-confirm @confirm="modify" value="修改"  />-->
        <!--            </div>-->
        <!--            <div class="form-btn-box" v-if="modifyState">-->
        <!--              <button-confirm @confirm="confirm" />-->
        <!--              <button-cancel @cancel="cancel" />-->
        <!--            </div>-->
        <!--          </form>-->
        <!--        </el-tab-pane>-->
        <!--        <el-tab-pane label="燃气充值审批" name="gasApprovalOfPowerChargeRecharge">-->
        <!--          <form>-->
        <!--            <div class="form-line">-->
        <!--              <div class="textBox" style="margin-right: 20px;">-->
        <!--                <b class="red">*</b>-->
        <!--                <span class="line-text">是否启用：</span>-->
        <!--              </div>-->
        <!--              <el-switch-->
        <!--                v-model="useFlagOnPage"-->
        <!--                active-text="是"-->
        <!--                :disabled="!modifyState"-->
        <!--                inactive-text="否">-->
        <!--              </el-switch>-->
        <!--            </div>-->
        <!--            <div class="form-line" v-for="(item, index) in flowDetails" :key="item.index">-->
        <!--              <div class="textBox" style="margin-right: 20px;">-->
        <!--                <b class="red" v-if="useFlagOnPage">*</b>-->
        <!--                <span class="line-text">{{item.index}}级审批人：</span>-->
        <!--              </div>-->
        <!--              <el-select-->
        <!--                v-model="item.accountCode"-->
        <!--                filterable-->
        <!--                remote-->
        <!--                reserve-keyword-->
        <!--                placeholder="请输入关键词"-->
        <!--                :loading="accountLoading"-->
        <!--                size="mini" style="width: 220px"-->
        <!--                :disabled="!modifyState"-->
        <!--                @change="accountChange(item, index)"-->
        <!--                :remote-method="accountRemoteMethod">-->
        <!--                <el-option-->
        <!--                  v-for="item in accountList"-->
        <!--                  :key="item.code"-->
        <!--                  :label="item._lable"-->
        <!--                  :value="item.code">-->
        <!--                </el-option>-->
        <!--              </el-select>-->
        <!--              <i class="el-icon-circle-plus-outline" style="line-height: 32px;font-size: 18px;color: #00A0E6;margin: 0 10px 0 10px;cursor: pointer;" @click="addFlowDetails()" v-if="item.index < 3 && item.index === flowDetails.length && modifyState"></i>-->
        <!--              <i class="el-icon-remove-outline" style="line-height: 32px;font-size: 18px;color: #f25721;margin: 0 0 0 10px;cursor: pointer;" @click="removeFlowDetails(index)" v-if="item.index > 1 && modifyState"></i>-->
        <!--            </div>-->

        <!--            <div class="form-btn-box" v-if="!modifyState && permissionCodes.indexOf('001013001') !== -1" style="display: flex;justify-content: center;">-->
        <!--              <button-confirm @confirm="modify" value="修改"  />-->
        <!--            </div>-->
        <!--            <div class="form-btn-box" v-if="modifyState">-->
        <!--              <button-confirm @confirm="confirm" />-->
        <!--              <button-cancel @cancel="cancel" />-->
        <!--            </div>-->
        <!--          </form>-->
        <!--        </el-tab-pane>-->
        <el-tab-pane label="账单修改审批" name="billModification">
          <form>
            <div class="form-line">
              <div class="textBox" style="margin-right: 20px;">
                <b class="red">*</b>
                <span class="line-text">是否启用：</span>
              </div>
              <el-switch
                v-model="useFlagOnPage"
                active-text="是"
                :disabled="!modifyState"
                inactive-text="否"
              >
              </el-switch>
            </div>
            <div
              class="form-line"
              v-for="(item, index) in flowDetails"
              :key="item.index"
            >
              <div class="textBox" style="margin-right: 20px;">
                <b class="red" v-if="useFlagOnPage">*</b>
                <span class="line-text">{{ item.index }}级审批人：</span>
              </div>
              <el-select
                v-model="item.accountCode"
                filterable
                remote
                reserve-keyword
                placeholder="请输入关键词"
                :loading="accountLoading"
                size="mini"
                style="width: 220px"
                :disabled="!modifyState"
                @change="accountChange(item, index)"
                :remote-method="accountRemoteMethod"
              >
                <el-option
                  v-for="item in accountList"
                  :key="item.code"
                  :label="item._lable"
                  :value="item.code"
                >
                </el-option>
              </el-select>
              <i
                class="el-icon-circle-plus-outline"
                style="line-height: 32px;font-size: 18px;color: #00A0E6;margin: 0 10px 0 10px;cursor: pointer;"
                @click="addFlowDetails()"
                v-if="
                  item.index < 3 &&
                    item.index === flowDetails.length &&
                    modifyState
                "
              ></i>
              <i
                class="el-icon-remove-outline"
                style="line-height: 32px;font-size: 18px;color: #f25721;margin: 0 0 0 10px;cursor: pointer;"
                @click="removeFlowDetails(index)"
                v-if="item.index > 1 && modifyState"
              ></i>
            </div>

            <div
              class="form-btn-box"
              v-if="!modifyState && permissionCodes.indexOf('001013001') !== -1"
              style="display: flex;justify-content: center;"
            >
              <button-confirm @confirm="modify" value="修改" />
            </div>
            <div class="form-btn-box" v-if="modifyState">
              <button-confirm @confirm="confirm" />
              <button-cancel @cancel="cancel" />
            </div>
          </form>
        </el-tab-pane>
        <!--        <el-tab-pane label="考勤审批" name="attendance">
          <form>
            <div class="form-line">
              <div class="textBox" style="margin-right: 20px;">
                <b class="red">*</b>
                <span class="line-text">是否启用：</span>
              </div>
              <el-switch
                v-model="useFlagOnPage"
                active-text="是"
                :disabled="!modifyState"
                inactive-text="否">
              </el-switch>
            </div>
            <div class="form-line" v-for="(item, index) in flowDetails" :key="item.index">
              <div class="textBox" style="margin-right: 20px;">
                <b class="red" v-if="useFlagOnPage">*</b>
                <span class="line-text">{{item.index}}级审批人：</span>
              </div>
              <el-select
                v-model="item.accountCode"
                filterable
                remote
                reserve-keyword
                placeholder="请输入关键词"
                :loading="accountLoading"
                size="mini" style="width: 220px"
                :disabled="!modifyState"
                @change="accountChange(item, index)"
                :remote-method="accountRemoteMethod">
                <el-option
                  v-for="item in accountList"
                  :key="item.code"
                  :label="item._lable"
                  :value="item.code">
                </el-option>
              </el-select>
              <i class="el-icon-circle-plus-outline" style="line-height: 32px;font-size: 18px;color: #00A0E6;margin: 0 10px 0 10px;cursor: pointer;" @click="addFlowDetails()" v-if="item.index < 3 && item.index === flowDetails.length && modifyState"></i>
              <i class="el-icon-remove-outline" style="line-height: 32px;font-size: 18px;color: #f25721;margin: 0 0 0 10px;cursor: pointer;" @click="removeFlowDetails(index)" v-if="item.index > 1 && modifyState"></i>
            </div>

            <div class="form-btn-box" v-if="!modifyState && permissionCodes.indexOf('001013001') !== -1" style="display: flex;justify-content: center;">
              <button-confirm @confirm="modify" value="修改"  />
            </div>
            <div class="form-btn-box" v-if="modifyState">
              <button-confirm @confirm="confirm" />
              <button-cancel @cancel="cancel" />
            </div>
          </form>
        </el-tab-pane>-->
        <el-tab-pane label="车位租赁审批" name="parking">
          <form>
            <div class="form-line">
              <div class="textBox" style="margin-right: 20px;">
                <b class="red">*</b>
                <span class="line-text">是否启用：</span>
              </div>
              <el-switch
                v-model="useFlagOnPage"
                active-text="是"
                :disabled="!modifyState"
                inactive-text="否"
              >
              </el-switch>
            </div>
            <div
              class="form-line"
              v-for="(item, index) in flowDetails"
              :key="item.index"
            >
              <div class="textBox" style="margin-right: 20px;">
                <b class="red" v-if="useFlagOnPage">*</b>
                <span class="line-text">{{ item.index }}级审批人：</span>
              </div>
              <el-select
                v-model="item.accountCode"
                filterable
                remote
                reserve-keyword
                placeholder="请输入关键词"
                :loading="accountLoading"
                size="mini"
                style="width: 220px"
                :disabled="!modifyState"
                @change="accountChange(item, index)"
                :remote-method="accountRemoteMethod"
              >
                <el-option
                  v-for="item in accountList"
                  :key="item.code"
                  :label="item._lable"
                  :value="item.code"
                >
                </el-option>
              </el-select>
              <i
                class="el-icon-circle-plus-outline"
                style="line-height: 32px;font-size: 18px;color: #00A0E6;margin: 0 10px 0 10px;cursor: pointer;"
                @click="addFlowDetails()"
                v-if="
                  item.index < 3 &&
                    item.index === flowDetails.length &&
                    modifyState
                "
              ></i>
              <i
                class="el-icon-remove-outline"
                style="line-height: 32px;font-size: 18px;color: #f25721;margin: 0 0 0 10px;cursor: pointer;"
                @click="removeFlowDetails(index)"
                v-if="item.index > 1 && modifyState"
              ></i>
            </div>

            <div
              class="form-btn-box"
              v-if="!modifyState && permissionCodes.indexOf('001013001') !== -1"
              style="display: flex;justify-content: center;"
            >
              <button-confirm @confirm="modify" value="修改" />
            </div>
            <div class="form-btn-box" v-if="modifyState">
              <button-confirm @confirm="confirm" />
              <button-cancel @cancel="cancel" />
            </div>
          </form>
        </el-tab-pane>
        <!--        <el-tab-pane label="数据上报审批" name="politicalCommunication">-->
        <!--          <form>-->
        <!--            <div class="form-line">-->
        <!--              <div class="textBox" style="margin-right: 20px;">-->
        <!--                <b class="red">*</b>-->
        <!--                <span class="line-text">是否启用：</span>-->
        <!--              </div>-->
        <!--              <el-switch-->
        <!--                v-model="useFlagOnPage"-->
        <!--                active-text="是"-->
        <!--                :disabled="!modifyState"-->
        <!--                inactive-text="否">-->
        <!--              </el-switch>-->
        <!--            </div>-->
        <!--            <div class="form-line" v-for="(item, index) in flowDetails" :key="item.index">-->
        <!--              <div class="textBox" style="margin-right: 20px;">-->
        <!--                <b class="red" v-if="useFlagOnPage">*</b>-->
        <!--                <span class="line-text">{{item.index}}级审批人：</span>-->
        <!--              </div>-->
        <!--              <el-select-->
        <!--                v-model="item.accountCode"-->
        <!--                filterable-->
        <!--                remote-->
        <!--                reserve-keyword-->
        <!--                placeholder="请输入关键词"-->
        <!--                :loading="accountLoading"-->
        <!--                size="mini" style="width: 220px"-->
        <!--                :disabled="!modifyState"-->
        <!--                @change="accountChange(item, index)"-->
        <!--                :remote-method="accountRemoteMethod">-->
        <!--                <el-option-->
        <!--                  v-for="item in accountList"-->
        <!--                  :key="item.code"-->
        <!--                  :label="item._lable"-->
        <!--                  :value="item.code">-->
        <!--                </el-option>-->
        <!--              </el-select>-->
        <!--              <i class="el-icon-circle-plus-outline" style="line-height: 32px;font-size: 18px;color: #00A0E6;margin: 0 10px 0 10px;cursor: pointer;" @click="addFlowDetails()" v-if="item.index < 3 && item.index === flowDetails.length && modifyState"></i>-->
        <!--              <i class="el-icon-remove-outline" style="line-height: 32px;font-size: 18px;color: #f25721;margin: 0 0 0 10px;cursor: pointer;" @click="removeFlowDetails(index)" v-if="item.index > 1 && modifyState"></i>-->
        <!--            </div>-->

        <!--            <div class="form-btn-box" v-if="!modifyState && permissionCodes.indexOf('001013001') !== -1" style="display: flex;justify-content: center;">-->
        <!--              <button-confirm @confirm="modify" value="修改"  />-->
        <!--            </div>-->
        <!--            <div class="form-btn-box" v-if="modifyState">-->
        <!--              <button-confirm @confirm="confirm" />-->
        <!--              <button-cancel @cancel="cancel" />-->
        <!--            </div>-->
        <!--          </form>-->
        <!--        </el-tab-pane>-->
        <el-tab-pane label="免费码授权人审批" name="freeCode">
          <form>
            <div class="form-line">
              <div class="textBox" style="margin-right: 20px;">
                <b class="red">*</b>
                <span class="line-text">是否启用：</span>
              </div>
              <el-switch
                v-model="useFlagOnPage"
                active-text="是"
                :disabled="!modifyState"
                inactive-text="否"
              >
              </el-switch>
            </div>
            <div
              class="form-line"
              v-for="(item, index) in flowDetails"
              :key="item.index"
            >
              <div class="textBox" style="margin-right: 20px;">
                <b class="red" v-if="useFlagOnPage">*</b>
                <span class="line-text">{{ item.index }}级审批人：</span>
              </div>
              <el-select
                v-model="item.accountCode"
                filterable
                remote
                reserve-keyword
                placeholder="请输入关键词"
                :loading="accountLoading"
                size="mini"
                style="width: 220px"
                :disabled="!modifyState"
                @change="accountChange(item, index)"
                :remote-method="accountRemoteMethod"
              >
                <el-option
                  v-for="item in accountList"
                  :key="item.code"
                  :label="item._lable"
                  :value="item.code"
                >
                </el-option>
              </el-select>
              <i
                class="el-icon-circle-plus-outline"
                style="line-height: 32px;font-size: 18px;color: #00A0E6;margin: 0 10px 0 10px;cursor: pointer;"
                @click="addFlowDetails()"
                v-if="
                  item.index < 3 &&
                    item.index === flowDetails.length &&
                    modifyState
                "
              ></i>
              <i
                class="el-icon-remove-outline"
                style="line-height: 32px;font-size: 18px;color: #f25721;margin: 0 0 0 10px;cursor: pointer;"
                @click="removeFlowDetails(index)"
                v-if="item.index > 1 && modifyState"
              ></i>
            </div>

            <div
              class="form-btn-box"
              v-if="!modifyState && permissionCodes.indexOf('001013001') !== -1"
              style="display: flex;justify-content: center;"
            >
              <button-confirm @confirm="modify" value="修改" />
            </div>
            <div class="form-btn-box" v-if="modifyState">
              <button-confirm @confirm="confirm" />
              <button-cancel @cancel="cancel" />
            </div>
          </form>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb'
import ButtonAdd from '../../../../components/Button/ButtonAdd'
import InputSearch from '../../../../components/Input/InputSearch'
import TableMain from '../../../../components/Table/TableMain'
import { api } from '../../../api/ConfigManagement'
import { errorHandler } from '../../../../utils/errorHandler'
import { nSuccess, nWarn } from '../../../../utils/notice'
import { bus } from '../../../../utils/bus'
import ButtonCancel from '../../../../components/Button/ButtonCancel'
import ButtonConfirm from '../../../../components/Button/ButtonConfirm'
import btnConfig from './components/btnConfig'
import configContent from './components/configContent'

// 默认空的一级单人审批节点（合同审批新版组件）
const createDefaultNodeConfig = () => [
  {
    accountCode: '',
    accountName: '',
    personCode: '',
    personName: '',
    index: 1,
    idx: 1,
    isSingle: true,
    numberType: '1',
    approvalMode: '1',
    gradeNum: '一',
    flowNodePersons: [
      {
        index: 1,
        idx: 1,
        accountCode: '',
        accountName: '',
        personCode: '',
        personName: '',
      },
    ],
  },
]

const gradeNumList = ['一', '二', '三']

export default {
  components: {
    ButtonConfirm,
    ButtonCancel,
    TableMain,
    InputSearch,
    ButtonAdd,
    Breadcrumb,
    btnConfig,
    configContent,
  },
  name: 'config-management',
  data() {
    return {
      permissionCodes: '',
      breadcrumb: [
        {
          value: '资源中心',
          name: 'yq-information',
        },
        {
          value: '配置管理',
        },
      ],
      addName: 'banner-add',
      searchPlaceholder: '标题',
      searchKey: '',
      deleteTipInfo: '是否确认删除此条配置？',

      approvalPageActiveName: 'checkInApplicationApproval',
      accountLoading: false,
      accountList: [],

      useFlagOnPage: false,
      flowDetails: [
        {
          accountCode: '',
          accountName: '',
          personCode: '',
          personName: '',
          index: 1,
        },
      ],
      modifyState: false,
      // 合同审批（新版组件）按钮文案：查看态为“修改”，编辑态为“确认”
      forecastText: '修改',
      // 合同审批（新版组件）true：查看/禁用态；false：可编辑
      isDisabled: true,
      // 合同审批（新版组件）审批节点配置（单人/多人、会签/或签）
      flowNodeConfigs: createDefaultNodeConfig(),
    }
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes
    this.getFlowByType()
    this.accountRemoteMethod()
  },
  methods: {
    tabClick() {
      this.useFlagOnPage = false
      this.flowDetails = [
        {
          accountCode: '',
          accountName: '',
          personCode: '',
          personName: '',
          index: 1,
        },
      ]
      this.modifyState = false
      this.isDisabled = true
      this.forecastText = '修改'
      this.getFlowByType()
    },
    // 查询配置
    getFlowByType() {
      // 合同审批走新版组件逻辑
      if (this.approvalPageActiveName === 'contractApproval') {
        this.getContractFlow()
        return
      }
      let type = ''
      if (this.approvalPageActiveName === 'checkInApplicationApproval') {
        type = '0'
      } else if (this.approvalPageActiveName === 'contractApproval') {
        type = '1'
      } else if (
        this.approvalPageActiveName === 'approvalOfPowerChargeRecharge'
      ) {
        type = '2'
      } else if (this.approvalPageActiveName === 'billModification') {
        type = '3'
      } else if (
        this.approvalPageActiveName === 'waterApprovalOfPowerChargeRecharge'
      ) {
        type = '4'
      } else if (this.approvalPageActiveName === 'incubate') {
        type = '5'
      } else if (this.approvalPageActiveName === 'attendance') {
        type = '6'
      } else if (this.approvalPageActiveName === 'parking') {
        type = '7'
      } else if (this.approvalPageActiveName === 'politicalCommunication') {
        type = '8'
      } else if (
        this.approvalPageActiveName === 'steamApprovalOfPowerChargeRecharge'
      ) {
        type = '9'
      } else if (
        this.approvalPageActiveName === 'gasApprovalOfPowerChargeRecharge'
      ) {
        type = '10'
      } else if (this.approvalPageActiveName === 'freeCode') {
        type = '11'
      }
      this.$axios
        .get(`${api.getFlowByType}/${type}`, {})
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            if (data.useFlag === '1') {
              this.useFlagOnPage = true
            } else {
              this.useFlagOnPage = false
            }
            if (data.flowDetails.length > 0) {
              this.flowDetails = data.flowDetails
            } else {
              this.flowDetails = [
                {
                  accountCode: '',
                  accountName: '',
                  personCode: '',
                  personName: '',
                  index: 1,
                },
              ]
            }
          }
        })
        .catch(errorHandler('查询失败'))
    },

    // 搜索账号
    accountRemoteMethod(query) {
      this.accountLoading = true
      this.$axios
        .post(api.getAccountList, {
          searchKey: query,
        })
        .then((res) => {
          if (res.data.retCode === 1) {
            this.accountLoading = false
            let data = res.data.data
            data.map((v) => {
              v._lable = `${v.name}/${v.actualName}/${v.phone}`
            })
            this.accountList = data
          }
        })
        .catch(errorHandler('获取账号列表失败'))
    },

    // 选择账号
    accountChange(value, index) {
      this.accountList.map((v) => {
        if (v.code === value.accountCode) {
          this.flowDetails[index].personCode = v.personCode
          this.flowDetails[index].personName = v.actualName
          this.flowDetails[index].accountName = v.name
        }
      })
    },

    // 添加一行
    addFlowDetails() {
      let flowDetailsLength = this.flowDetails.length
      let obj = {
        accountCode: '',
        accountName: '',
        personCode: '',
        personName: '',
        index: flowDetailsLength + 1,
      }
      this.flowDetails.push(obj)
    },

    // 移除一行
    removeFlowDetails(index) {
      this.flowDetails.splice(index, 1)
      this.flowDetails.map((v, i) => {
        v.index = i + 1
      })
    },

    // 点击修改
    modify() {
      this.modifyState = true
    },

    // 取消修改
    cancel() {
      this.modifyState = false
      this.getFlowByType()
    },

    // 修改
    confirm() {
      let useFlag = '0'
      if (this.useFlagOnPage) {
        useFlag = '1'
      } else {
        useFlag = '0'
      }
      let type = ''
      if (this.approvalPageActiveName === 'checkInApplicationApproval') {
        type = '0'
      } else if (this.approvalPageActiveName === 'contractApproval') {
        type = '1'
      } else if (
        this.approvalPageActiveName === 'approvalOfPowerChargeRecharge'
      ) {
        type = '2'
      } else if (this.approvalPageActiveName === 'billModification') {
        type = '3'
      } else if (
        this.approvalPageActiveName === 'waterApprovalOfPowerChargeRecharge'
      ) {
        type = '4'
      } else if (this.approvalPageActiveName === 'incubate') {
        type = '5'
      } else if (this.approvalPageActiveName === 'attendance') {
        type = '6'
      } else if (this.approvalPageActiveName === 'parking') {
        type = '7'
      } else if (this.approvalPageActiveName === 'politicalCommunication') {
        type = '8'
      } else if (
        this.approvalPageActiveName === 'steamApprovalOfPowerChargeRecharge'
      ) {
        type = '9'
      } else if (
        this.approvalPageActiveName === 'gasApprovalOfPowerChargeRecharge'
      ) {
        type = '10'
      } else if (this.approvalPageActiveName === 'freeCode') {
        type = '11'
      }
      this.$axios
        .post(api.updateFlowByType, {
          type,
          useFlag,
          flowDetails: this.flowDetails,
        })
        .then((res) => {
          if (res.data.retCode === 1) {
            nSuccess('修改成功')
            this.modifyState = false
            this.getFlowByType()
          }
        })
        .catch(errorHandler('修改失败'))
    },

    // ===== 合同审批新版组件逻辑（config-content / btn-config，接口 flowNodeConfigs） =====

    // 查询合同审批配置
    getContractFlow() {
      this.$axios
        .get(`${api.getFlowByType}/1`, {})
        .then((res) => {
          if (res.data.retCode === 1) {
            const data = res.data.data || {}
            this.useFlagOnPage = String(data.useFlag) === '1'
            let list = []
            if (data.flowNodeConfigs && data.flowNodeConfigs.length > 0) {
              list = data.flowNodeConfigs
            } else if (data.flowDetails && data.flowDetails.length > 0) {
              // 兼容旧版 flowDetails 结构（每级单人）
              list = data.flowDetails
            }
            if (list.length > 0) {
              this.flowNodeConfigs = list.map((v, i) =>
                this.transferNodeConfig(v, i),
              )
            } else {
              this.flowNodeConfigs = createDefaultNodeConfig()
            }
            // 同步到 config-content 内部展示
            this.$nextTick(() => {
              if (this.$refs.configContentRef) {
                this.$refs.configContentRef.useFlagOnPage = this.useFlagOnPage
                this.$refs.configContentRef.flowDetails = this.flowNodeConfigs
              }
            })
          }
        })
        .catch(errorHandler('查询失败'))
    },

    // 把后端返回/旧版数据转换为节点展示结构
    transferNodeConfig(v, i) {
      const node = Object.assign({}, v)
      node.index = i + 1
      node.idx = i + 1
      node.approvalMode = v.approvalMode || '1'
      node.gradeNum = gradeNumList[i] || '三'
      if (String(v.numberType) === '2') {
        node.isSingle = false
        node.flowNodePersons = (v.flowNodePersons || []).map((p, j) => {
          const person = Object.assign({}, p)
          person.index = j + 1
          person.idx = j + 1
          return person
        })
        // 多人节点至少保留一行，便于展示/新增审批人
        if (node.flowNodePersons.length === 0) {
          node.flowNodePersons = [
            {
              index: 1,
              idx: 1,
              accountCode: '',
              accountName: '',
              personCode: '',
              personName: '',
            },
          ]
        }
      } else {
        // 单人：兼容节点直接存放 person 字段，以及存于 flowNodePersons[0] 两种结构
        node.isSingle = true
        node.numberType = '1'
        const p0 =
          v.flowNodePersons && v.flowNodePersons.length
            ? v.flowNodePersons[0]
            : {}
        node.accountCode = v.accountCode || p0.accountCode || ''
        node.accountName = v.accountName || p0.accountName || ''
        node.personCode = v.personCode || p0.personCode || ''
        node.personName = v.personName || p0.personName || ''
        node.flowNodePersons = [
          {
            index: 1,
            idx: 1,
            accountCode: node.accountCode,
            accountName: node.accountName,
            personCode: node.personCode,
            personName: node.personName,
          },
        ]
      }
      return node
    },

    // config-content 启用开关改变
    changeSwitch(e) {
      this.useFlagOnPage = e
    },

    // config-content 节点数据变化同步到父级
    onNodeConfigChange(val) {
      this.flowNodeConfigs = val
    },

    // 点击修改（合同新版）
    modifyConfig() {
      this.isDisabled = false
      this.forecastText = '确认'
    },

    // 取消修改（合同新版）
    cancelConfig() {
      this.isDisabled = true
      this.forecastText = '修改'
      this.getContractFlow()
    },

    // 保存修改（合同新版，提交 flowNodeConfigs）
    confirmContract() {
      const useFlag = this.useFlagOnPage ? '1' : '0'
      // 启用的审批必须选择审批人
      if (useFlag === '1') {
        for (let i = 0; i < this.flowNodeConfigs.length; i++) {
          const node = this.flowNodeConfigs[i]
          const gradeNum = gradeNumList[i] || '三'
          if (node.isSingle) {
            if (!node.personCode && !node.accountCode) {
              nWarn(`第${gradeNum}级审批人不能为空`)
              return
            }
          } else {
            const persons = node.flowNodePersons || []
            const empty = persons.some((p) => !p.personCode && !p.accountCode)
            if (!persons.length || empty) {
              nWarn(`第${gradeNum}级审批人不能为空`)
              return
            }
          }
        }
      }
      const flowNodeConfigs = this.flowNodeConfigs.map((v, i) => {
        const item = JSON.parse(JSON.stringify(v))
        item.idx = i + 1
        item.index = i + 1
        item.numberType = v.isSingle ? '1' : '2'
        item.approvalMode = v.approvalMode || '1'
        if (v.isSingle) {
          item.flowNodePersons =
            item.flowNodePersons && item.flowNodePersons.length
              ? [Object.assign({}, item.flowNodePersons[0])]
              : [{}]
          const person = item.flowNodePersons[0]
          // 单人节点以节点字段为主，兼容仅存于 flowNodePersons[0] 的情况
          person.accountCode = v.accountCode || person.accountCode || ''
          person.accountName = v.accountName || person.accountName || ''
          person.personCode = v.personCode || person.personCode || ''
          person.personName = v.personName || person.personName || ''
          person.index = 1
          person.idx = 1
        } else {
          item.flowNodePersons = (item.flowNodePersons || []).map((p, j) => {
            p.index = j + 1
            p.idx = j + 1
            return p
          })
        }
        return item
      })
      this.$axios
        .post(api.updateFlowByType, {
          type: '1',
          useFlag,
          flowNodeConfigs,
        })
        .then((res) => {
          if (res.data.retCode === 1) {
            nSuccess('修改成功')
            this.isDisabled = true
            this.forecastText = '修改'
            this.getContractFlow()
          }
        })
        .catch(errorHandler('修改失败'))
    },
  },
  watch: {
    useFlagOnPage(value) {
      if (!value) {
        this.flowDetails = [
          {
            accountCode: '',
            accountName: '',
            personCode: '',
            personName: '',
            index: 1,
          },
        ]
      }
    },
  },
}
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.approval-config-area {
  width: 90%;
  margin: 0 auto;
  padding: 20px 0 40px;
  text-align: left;
}
.red {
  color: #ff0000;
}
.form-line {
  margin: 20px 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.form-line > span {
  font-size: 12px;
  color: #97a8be;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 120px;
  text-align: right;
}
.form-btn-box {
  width: 530px;
  padding: 0 124px;
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}
</style>
<style lang="less">
.approval-manage {
  .approvalBox {
    margin-top: 20px;
  }
  .el-tabs--top.el-tabs--card .el-tabs__item:last-child {
    width: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/ResourceCenter/configManagement/ApprovalConfig/ApprovalManage.vue